import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";

import { LockOkIcon } from "@/assets/icons";
import { useNavigation } from "@/shared/hooks";

import { StyledConfirmationContainer, StyledIndications } from "../../../styled";
import { StyledMessageTitle, StyledPRelativeXs } from "./styled";

const PasswordUpdated: FC = () => {
    const { t } = useTranslation();
    const { navToRoot } = useNavigation();

    return (
        <>
            <div className="title">{t("ResetPassword.PasswordUpdated.PasswordUpdated")}</div>
            <StyledConfirmationContainer>
                <LockOkIcon />
                <StyledMessageTitle>
                    <b>{t("ResetPassword.PasswordUpdated.PasswordSuccess")}</b>
                </StyledMessageTitle>

                <StyledIndications>
                    <p>{t("ResetPassword.PasswordUpdated.Message")}</p>
                </StyledIndications>
            </StyledConfirmationContainer>

            <StyledPRelativeXs className="form-bottom-container">
                <Button data-testid="button_back_to_login" fullWidth onClick={() => navToRoot()}>
                    {t("ResetPassword.EmailSent.BackToLogin")}
                </Button>
            </StyledPRelativeXs>
        </>
    );
};

export default PasswordUpdated;
